import axios from "axios";

// Function to fetch data
export const fetchData = async (form, dispatch, createNewForm) => {
  console.log("hello", form);
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API}/forms/${form._id}`,
      form
    );
    console.log("responses", response);
    dispatch(createNewForm(response.data.updatedForm));
  } catch (error) {
    console.log(error);
  }
};
